import confetti from 'canvas-confetti';

export function dispararGol() {
  const duracao = 2200;
  const fim = Date.now() + duracao;

  const cores = ['#FFDF00', '#006437', '#FFFFFF', '#003087'];

  // Dois canhões nas laterais inferiores
  const esquerda = confetti.create(null, { resize: true, useWorker: true });
  const direita  = confetti.create(null, { resize: true, useWorker: true });

  (function frame() {
    esquerda({
      particleCount: 6,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 1 },
      colors: cores,
      scalar: 1.1,
    });
    direita({
      particleCount: 6,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 1 },
      colors: cores,
      scalar: 1.1,
    });

    if (Date.now() < fim) requestAnimationFrame(frame);
  })();

  // Burst central
  confetti({
    particleCount: 80,
    spread: 100,
    origin: { x: 0.5, y: 0.6 },
    colors: cores,
    scalar: 1.2,
    startVelocity: 35,
  });
}
